// Mapping nama tool MCP → metadata visual (icon, label manusia, kategori warna).
// Dipakai oleh ChatToolTimeline untuk menampilkan aktivitas tool yang sedang
// berjalan dengan tampilan profesional dan informatif.
//
// Pencocokan dilakukan dengan keyword/prefix supaya tool baru yang mengikuti
// konvensi penamaan MCPUprint* otomatis dapat icon yang relevan tanpa harus
// di-register manual.

const RULES = [
  // Web tools
  { match: /web_search/i,       icon: '🔎', label: 'Pencarian web',          category: 'web' },
  { match: /web_fetch|fetch_url/i, icon: '🌐', label: 'Mengambil halaman',  category: 'web' },

  // ── Google Merchant Center (Content API) — HARUS sebelum rule /product/ generic ──
  // WRITE: mengubah katalog Merchant LIVE → kategori 'ads-write' (amber, menonjol).
  { match: /upsert_merchant_product/i, icon: '🛒', label: 'Simpan produk Merchant', category: 'ads-write' },
  { match: /delete_merchant_product/i, icon: '🗑️', label: 'Hapus produk Merchant',  category: 'ads-write' },
  { match: /merchant_api_request/i,    icon: '✏️', label: 'Tulis Merchant API',     category: 'ads-write' },
  // READ / explore (health, list, get, issues, report, api_get):
  { match: /merchant/i,                icon: '🛒', label: 'Google Merchant',         category: 'merchant' },

  // Product catalog
  { match: /product/i,          icon: '📦', label: 'Katalog produk',         category: 'product' },

  // Knowledge / FAQ
  { match: /knowledge|faq/i,    icon: '📚', label: 'Basis pengetahuan',      category: 'knowledge' },

  // Sales / revenue
  { match: /sales|revenue|order/i, icon: '💰', label: 'Data penjualan',      category: 'sales' },

  // ── Meta Ads (Facebook + Instagram) — server meta_ads, read-only. HARUS sebelum
  //    rule generic /insight/ (get_meta_insights) & /ads|campaign/ di bawah.
  //    list_meta_adsets di atas list_meta_ads ("list_meta_ads" substring "...adsets"). ──
  { match: /meta_health_check/i,        icon: '🩺', label: 'Cek koneksi Meta',   category: 'ads-read' },
  { match: /get_meta_account_summary/i, icon: '🔷', label: 'Ringkasan Meta Ads', category: 'ads-read' },
  { match: /list_meta_campaigns/i,      icon: '🔷', label: 'Campaign Meta',      category: 'ads-read' },
  { match: /list_meta_adsets/i,         icon: '🔷', label: 'Ad set Meta',        category: 'ads-read' },
  { match: /list_meta_ads/i,            icon: '🔷', label: 'Iklan Meta',         category: 'ads-read' },
  { match: /get_meta_insights/i,        icon: '🔷', label: 'Insights Meta Ads',  category: 'ads-read' },
  { match: /list_meta_audiences/i,      icon: '👥', label: 'Audience Meta',       category: 'ads-read' },
  { match: /compare_meta_periods/i,     icon: '🔷', label: 'Banding periode Meta', category: 'ads-read' },
  { match: /meta_api_get/i,             icon: '🔷', label: 'Meta API (baca)',     category: 'ads-read' },
  // WRITE Meta — kategori ads-write (amber, menonjol):
  { match: /meta_set_status/i,          icon: '⏯️', label: 'Ubah status Meta',    category: 'ads-write' },
  { match: /meta_update_budget/i,       icon: '💸', label: 'Ubah budget Meta',    category: 'ads-write' },
  { match: /meta_api_write/i,           icon: '✏️', label: 'Tulis Meta API',      category: 'ads-write' },

  // Customer / cohort / 360
  { match: /customer|cohort|insight/i, icon: '👥', label: 'Insight pelanggan', category: 'customer' },

  // ── Google / Meta Ads & GA4 — HARUS sebelum rule generic /ads/ di bawah ──
  // WRITE: mengubah akun iklan LIVE → kategori 'ads-write' (di-styling amber, menonjol).
  { match: /set_campaign_status/i,    icon: '⏯️', label: 'Ubah status campaign', category: 'ads-write' },
  { match: /update_campaign_budget/i, icon: '💸', label: 'Ubah budget campaign', category: 'ads-write' },
  { match: /update_bidding/i,         icon: '🎯', label: 'Ubah strategi bid',    category: 'ads-write' },
  { match: /google_ads_mutate/i,      icon: '✏️', label: 'Ubah Google Ads',      category: 'ads-write' },
  // READ:
  { match: /ads_health_check/i,       icon: '🩺', label: 'Cek koneksi iklan',    category: 'ads-read' },
  { match: /get_google_ads_summary|google_ads_query/i, icon: '🟦', label: 'Google Ads', category: 'ads-read' },
  { match: /get_meta_ads_summary/i,   icon: '🔷', label: 'Meta Ads',             category: 'ads-read' },
  { match: /get_ga4_traffic|ga4/i,    icon: '📊', label: 'Google Analytics 4',   category: 'ads-read' },
  // Search Console (SEO organik) — HARUS sebelum rule generic /^query_/ & /traffic/ di bawah.
  { match: /inspect_gsc_url/i,                 icon: '🔬', label: 'Inspeksi URL (index)', category: 'ads-read' },
  { match: /gsc|search_console|searchanalytics/i, icon: '🔎', label: 'Search Console',  category: 'ads-read' },
  // SEO analytics derivatif (di atas data Search Console live) — nama tak berawalan gsc_:
  { match: /detect_keyword_cannibalization/i, icon: '🔀', label: 'Kanibalisasi keyword',  category: 'ads-read' },
  { match: /ctr_vs_position_opportunity/i,    icon: '✨', label: 'Peluang CTR SEO',       category: 'ads-read' },
  { match: /page_performance_drill/i,         icon: '📄', label: 'Drill halaman SEO',     category: 'ads-read' },

  // ── Analitik iklan derivatif (uprint_ads + meta_ads) — sebelum fallback generic /ads/ ──
  { match: /cross_channel_roas/i,        icon: '💹', label: 'ROAS lintas channel',  category: 'ads-read' },
  { match: /detect_campaign_anomalies/i, icon: '⚠️',  label: 'Anomali campaign',     category: 'anomaly' },
  { match: /get_campaign_pacing/i,       icon: '⏱️', label: 'Budget pacing',        category: 'ads-read' },
  { match: /get_platform_performance/i,  icon: '📱', label: 'Performa placement',    category: 'ads-read' },
  { match: /rank_creatives/i,            icon: '🏆', label: 'Ranking kreatif',       category: 'ads-read' },
  { match: /detect_creative_fatigue/i,   icon: '🥵', label: 'Creative fatigue',      category: 'ads-read' },

  // Ads / marketing (generic fallback)
  { match: /ads|campaign|marketing/i, icon: '📣', label: 'Performa iklan',   category: 'ads' },

  // Forecast / prediction
  { match: /forecast|predict/i, icon: '📈', label: 'Forecast',               category: 'forecast' },

  // Anomaly detection
  { match: /anomaly|outlier/i,  icon: '⚠️',  label: 'Deteksi anomali',       category: 'anomaly' },

  // Geo / region
  { match: /geo|region|location/i, icon: '🗺️', label: 'Analisis geografis', category: 'geo' },

  // Competitor
  { match: /competitor|compete/i, icon: '⚔️', label: 'Analisis kompetitor',  category: 'competitor' },

  // Experiment / AB test
  { match: /experiment|ab_test/i, icon: '🧪', label: 'Eksperimen',           category: 'experiment' },

  // Chat history / memory
  { match: /chat_history|chat_session/i, icon: '💬', label: 'Riwayat chat',  category: 'chat' },

  // AI report
  { match: /ai_report|report/i, icon: '📊', label: 'Laporan AI',             category: 'report' },

  // Traffic
  { match: /traffic|visitor/i,  icon: '🚦', label: 'Traffic',                category: 'traffic' },

  // Generic SQL/query
  { match: /^query_|sql/i,      icon: '🗄️', label: 'Query database',        category: 'query' },
]

const DEFAULT_META = { icon: '🛠', label: 'Tool', category: 'generic' }

export function getToolMeta(name) {
  if (!name) return { ...DEFAULT_META }
  for (const rule of RULES) {
    if (rule.match.test(name)) {
      return { icon: rule.icon, label: rule.label, category: rule.category }
    }
  }
  return { ...DEFAULT_META, label: humanize(name) }
}

// Format ringkas argumen tool untuk preview line di timeline
// (mis. `web_search({query:"churn analysis"})` → `"churn analysis"`).
export function summarizeToolInput(name, input) {
  if (!input || typeof input !== 'object') return ''
  if (/web_search/i.test(name) && input.query) return `"${trunc(String(input.query), 60)}"`
  if (/web_fetch/i.test(name) && input.url) {
    try { return new URL(input.url).host } catch { return trunc(String(input.url), 40) }
  }
  if (input.query)    return `"${trunc(String(input.query), 60)}"`
  if (input.question) return `"${trunc(String(input.question), 60)}"`
  if (input.sql)      return trunc(String(input.sql).replace(/\s+/g, ' '), 80)
  if (input.id)       return `id: ${input.id}`
  if (input.term)     return `"${trunc(String(input.term), 60)}"`

  // Google Ads WRITE — surface aksi konkret yang akan dijalankan.
  if (/set_campaign_status/i.test(name)) {
    const who = input.campaign || input.campaignName || input.campaignId || input.name
    const parts = [input.status, who].filter(Boolean).map(v => trunc(String(v), 36))
    if (parts.length) return parts.join(': ')
  }
  if (/update_campaign_budget/i.test(name)) {
    const b = input.budget ?? input.amount ?? input.dailyBudget ?? input.budgetMicros
    if (b != null) return `Budget → ${trunc(String(b), 40)}`
  }
  if (/update_bidding/i.test(name)) {
    const b = input.strategy ?? input.bidStrategy ?? input.targetCpa ?? input.targetRoas ?? input.bid
    if (b != null) return `Bid → ${trunc(String(b), 40)}`
  }
  if (/google_ads_mutate/i.test(name)) {
    const op  = input.operation || 'mutate'
    const res = input.resource || input.resourceName || input.entity
    const s = [op, res].filter(Boolean).map(v => trunc(String(v), 30)).join(' ')
    if (s) return s
  }
  // Rentang waktu — banyak tool ads/GA4 memakai `days`.
  if (input.days != null) return `rentang ${input.days} hari`

  // Generic: ambil 2 field pertama yang nilainya scalar
  const parts = []
  for (const [k, v] of Object.entries(input)) {
    if (parts.length >= 2) break
    if (v == null) continue
    if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') {
      parts.push(`${k}: ${trunc(String(v), 30)}`)
    }
  }
  return parts.join(' · ')
}

export function formatElapsed(ms) {
  if (ms == null || ms < 0) return ''
  if (ms < 1000) return `${(ms / 1000).toFixed(1)}s`
  if (ms < 60_000) return `${(ms / 1000).toFixed(1)}s`
  const m = Math.floor(ms / 60_000)
  const s = Math.round((ms % 60_000) / 1000)
  return `${m}m ${s}s`
}

function trunc(s, n) {
  if (!s) return ''
  return s.length > n ? s.slice(0, n - 1) + '…' : s
}

function humanize(name) {
  return String(name)
    .replace(/^mcp[_-]?/i, '')
    .replace(/^uprint[_-]?/i, '')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, c => c.toUpperCase())
}
